import { Outlet, useMatchRoute, useParams } from '@tanstack/react-router';
import { useUserPermissions } from '@anytag/auth';
import { usePartnerAgencyQuery, PartnerAgencyWithCompanies } from '@anytag/graphql';
import { ButtonLink, RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { PartnerTabs } from '@anytag/shared-organisms';
import { PartnerDetailsProvider } from './partner-details-context';

export const PartnerDetails = () => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const params = useParams({ from: '/_private-routes/partner/$id' });
  const matchByPath = useMatchRoute();
  const { data, loading } = usePartnerAgencyQuery({
    fetchPolicy: 'network-only',
    variables: { pk: Number(params.id) },
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/partner' });
    }
  });
  const { hideAddUserBtn } = useUserPermissions();
  const hasAddUserLink = !hideAddUserBtn && matchByPath({ to: '/partner/$id/users' });

  const partner = data?.partnerAgency;

  return (
    <RenderDataWithFallback loading={loading} hasNoData={!partner}>
      <PartnerDetailsProvider values={{ partner: partner as PartnerAgencyWithCompanies }}>
        <div>
          <Header>
            {hasAddUserLink ? (
              <ButtonLink
                to="/user/add"
                variant="solid"
                title={t('Button.Add User')}
                className="ml-auto min-w-27 capitalize"
                prefixIcon={{ icon: 'plus', size: '10px' }}
              />
            ) : null}
          </Header>

          <div>
            <PartnerTabs partnerId={Number(partner?.id)} />
            <Outlet />
          </div>
        </div>
      </PartnerDetailsProvider>
    </RenderDataWithFallback>
  );
};
